import React from "react";
import styled, { css } from "styled-components";
export var EButtonSize;
(function (EButtonSize) {
    EButtonSize["SMALL"] = "small";
    EButtonSize["LARGE"] = "large";
})(EButtonSize || (EButtonSize = {}));
;
export var EButtonColor;
(function (EButtonColor) {
    EButtonColor["PRIMARY"] = "primary";
    EButtonColor["SECONDARY"] = "secondary";
    EButtonColor["SUCCESS"] = "success";
    EButtonColor["WARNING"] = "warning";
    EButtonColor["DANGER"] = "danger";
    EButtonColor["REVERSE"] = "reverse";
})(EButtonColor || (EButtonColor = {}));
;
const BumpBtnWrapper = styled.div `
    width: 162px;
    height: 40px;
    padding: 8px 8px 8px 12px;
    border-radius: 4px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    min-width: ${({ minWidth }) => minWidth || 0}px;
    width: 100%;

    &:disabled {
        cursor: not-allowed;
        text-decoration: none;
    }

    /* color */
    ${({ color }) => {
    if (color === EButtonColor.SUCCESS) {
        return css `
                color: #fff;
                background-color: #009100;
            `;
    }
    if (color === EButtonColor.PRIMARY) {
        return css `
                color: #4B4F5E;
                background-color: #F1F4F7;
            `;
    }
    if (color === EButtonColor.DANGER) {
        return css `
                color: #fff;
                background-color: #BC362F;
            `;
    }
    return css `
                color: #6B7270;
                background-color: #F1F4F7;
            `;
}}
`;
export const BumpButton = ({ children, size, color, onClick, className }) => {
    return React.createElement(BumpBtnWrapper, { size: size, color: color, onClick: onClick, className: className }, children);
};
//# sourceMappingURL=index.js.map